import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BankingDialogComponent } from '@pages/banking/banking-dialog.component';
import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { Subject, takeUntil } from 'rxjs';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-account-dialog',
  templateUrl: './account-dialog.component.html',
  styleUrls: ['./account-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountDialogComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;
  accountDialoge: any = [];
  addData: any = [];
  SendArray: any = [];
  private _unsubscribeAll$: Subject<void> = new Subject();
  public accDialoge = {
    Name: ' ',
    AccNo: ' ',
    AccType: ' ',
  };
  ChartHandlingData: {
    ClickType: string;
    UseTrust: string;
    PopUp: string;
    Lable: string;
  };
  constructor(
    public dialog: MatDialog,
    public behaviorService: BehaviorService,
    public dialogRef: MatDialogRef<AccountDialogComponent>,
    private _mainAPiServiceService: MainAPiServiceService,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingAccountDialogComponent');
    this.behaviorService.dialogClose$.pipe(takeUntil(this._unsubscribeAll$)).subscribe((result) => {
      if (result != null) {
        if (result.MESSAGE == 'Not logged in') {
          this.dialogRef.close(false);
        }
      }
    });
    this.behaviorService.APIretryCall$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(
      (result) => {
        if (
          localStorage.getItem('istrackid') == 'SystemSettingAccountDialogComponent' &&
          result['click'] &&
          result['data']['GetSystem']
        ) {
          this.ngOnInit();
        }
      },
    );
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.SysytemAccountDIalogData$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(
      (result) => {
        if (result) {
          this.accountDialoge = result;
        }
      },
    );
    // this._mainAPiServiceService.getSetData({ ACCOUNTGUIDNAME: this.accountDialoge.ACCOUNTGUIDNAME }, 'GetSystem').pipe(takeUntil(this._unsubscribeAll$)).subscribe(response => {
    //   if (response.CODE == '200' || response.STATUS == "success") {
    //   }
    //   else if (response.MESSAGE == 'Not logged in') {
    //     this.dialogRef.close(false);
    //   }
    // });
    this.accDialoge.Name = this.accountDialoge.DESCRIPTION;
    this.accDialoge.AccNo = this.accountDialoge.ACCOUNTNO;
    this.accDialoge.AccType = this.accountDialoge.ACCOUNTTYPE;
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This function is used to open Account data value.
   */
  openAccount(type): void {
    this.SendArray = [];
    this.ChartHandlingData = {
      ClickType: 'WithoutTrust',
      UseTrust: 'No',
      PopUp: '',
      Lable: 'Select Account',
    };
    localStorage.setItem('ChartURL', JSON.stringify(this.ChartHandlingData));
    this.behaviorService.trustDuplicateModuleHandling(this.ChartHandlingData);
    const dialogRef = this.dialog.open(BankingDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.W900,
      data: { AccountType: type, FromWhere: 'systemSetting' },
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
    });
    //this.accDialoge.AccNo=result.name;
    dialogRef.afterClosed().subscribe((result) => {
      localStorage.setItem('istrackid', 'SystemSettingAccountDialogComponent');
      if (result) {
        // this.accDialoge.AccNo = result.name;
        this.accDialoge.AccNo =
          result.ACCOUNTCLASS + ' - ' + result.ACCOUNTNUMBER + ' ' + result.ACCOUNTNAME;
        this.SendArray.push({
          ACCOUNTNUMBER: result.ACCOUNTCLASS + ' - ' + result.ACCOUNTNUMBER,
          ACCOUNTNAME: result.ACCOUNTNAME,
          ACCOUNTGUID: result.ACCOUNTGUID,
          ACCOUNTGUIDNAME: this.accountDialoge.ACCOUNTGUIDNAME,
        });
      }
    });
  }

  /**
   * This function is used to Save the Click data value.
   */
  SaveClick(): void {
    this.dialogRef.close(this.SendArray);
  }
}
